import { draftPropType } from '~publish/legacy/composer/composer/components/ComposerPropTypes'
import { PostTypeShort } from '~publish/legacy/post/constants'
import { ShortBar } from '~publish/legacy/composer/composer/components/youtube/ShortBar/ShortBar'
import type Draft from '../../entities/Draft/Draft'
import type { YoutubeChannelData } from '../../entities/Draft/types'

function isShortPost(
  draft: Draft,
): draft is Draft & { channelData: { youtube: YoutubeChannelData } } {
  return draft.isShortPost()
}

const YoutubeComposerBar = ({
  draft,
}: {
  draft: Draft
}): JSX.Element | null => {
  if (!isShortPost(draft)) {
    return null
  }

  const data = draft.channelData.youtube

  return (
    <div>{draft.updateType === PostTypeShort && <ShortBar data={data} />}</div>
  )
}

YoutubeComposerBar.propTypes = {
  draft: draftPropType.isRequired,
}

export default YoutubeComposerBar
